// 景区/门票装修组件的编辑器预览样例数据。
// 仅用于 B 端画布占位展示；真实内容由 C 端页面（moduleCode=scenic 的
// scenic-home / scenic-ticket）按业务接口渲染，与 scenic.vue / ticket.vue
// 拆解出的区块一一对应。金额单位：分（与 C 端 ScenicTicket.finalPrice 一致）。
export interface ScenicPreviewScenic {
  name: string
  rank: string
  hasRank: boolean
  pricePerPerson: string
  businessStatusCode: string
  hours: string
  address: string
  distanceKm: string
  mobile: string
}

export const SAMPLE_SCENIC: ScenicPreviewScenic = {
  name: '云山景区',
  rank: '4.8',
  hasRank: true,
  pricePerPerson: '120',
  businessStatusCode: 'OPEN',
  hours: '08:00-17:30',
  address: '云山路 1 号',
  distanceKm: '3.2',
  mobile: '0571-8000-1234',
}

export interface ScenicPreviewTicket {
  name: string
  priceCents: number
  sales: number
  tags: string[]
  service: string[]
  hasServiceDesc: boolean
  notice: string[]
  hasNoticeDesc: boolean
}

export const SAMPLE_TICKET: ScenicPreviewTicket = {
  name: '成人票（含观光车）',
  priceCents: 9900,
  sales: 1268,
  tags: ['成人票', '当日可订', '可退改'],
  service: ['随买随用', '无需取票，刷码入园'],
  hasServiceDesc: true,
  notice: ['退改规则以票种说明为准'],
  hasNoticeDesc: true,
}

export interface ScenicPreviewGoodsItem {
  name: string
  tags: string[]
  priceCents: number
  sales: number
}

export const SAMPLE_GOODS: ScenicPreviewGoodsItem[] = [
  { name: '成人票', tags: ['成人票'], priceCents: 9900, sales: 1268 },
  { name: '儿童 / 学生票', tags: ['儿童票'], priceCents: 4900, sales: 862 },
  { name: '双人套票', tags: ['套票'], priceCents: 16800, sales: 530 },
  { name: '观光车单程票', tags: ['观光车'], priceCents: 1500, sales: 2041 },
]

/** 分 → “¥xx.xx”（与 C 端 unitPrice 视觉近似，编辑器预览用）。 */
export function scenicYuan(cents: number): string {
  return `¥${(cents / 100).toFixed(2)}`
}

/** 营业状态文案（与 C 端 scenic.vue / ticket.vue 的口径一致）。 */
export function scenicStatusText(statusCode: string): string {
  if (statusCode === 'OPEN') return '开放中'
  if (statusCode === 'CLOSED') return '已关闭'
  return '非营业时间'
}
